import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import Galeria from './components/Galeria';
import About from './components/About';
import MisionVision from './components/MisionVision';
import BannerCTA from './components/BannerCTA';
import WhyUs from './components/WhyUs';
import Facturacion from './components/Facturacion';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  return (
    <div className="app">
      <Navbar />
      <Hero />
      <Products />
      <About />
      <Galeria />
      <MisionVision />
      <BannerCTA />
      <WhyUs />
      <Facturacion />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
